/* Dirksen Scooters — homepagesecties
   Drie losse onderdelen: de roulerende USP-balk, de hero en de
   productcarrousel. Elk werkt zelfstandig; zonder dit script blijft alles
   leesbaar en scrollbaar. */

(function () {
  'use strict';

  function mediaQuery(query) {
    if (!window.matchMedia) {
      return { matches: false, addEventListener: function () {} };
    }
    return window.matchMedia(query);
  }

  function claim(el) {
    // Een sectie kan haar script meerdere keren op één pagina laden — de
    // carrousel staat drie keer op de homepage. Elke <script src> voert het
    // bestand opnieuw uit, dus zonder deze markering krijgt hetzelfde element
    // meerdere timers en meerdere klikhandlers.
    if (el.dataset.dkReady === '1') return false;
    el.dataset.dkReady = '1';
    return true;
  }

  /* USP-balk ------------------------------------------------------------ */

  function setupUsp(bar) {
    if (!claim(bar)) return;
    var items = bar.querySelectorAll('[data-dk-usp-item]');
    if (items.length < 2) return;

    var interval = (parseInt(bar.dataset.dkInterval, 10) || 5) * 1000;
    var wide = mediaQuery('(min-width: 768px)');
    var index = 0;
    var timer = null;
    var paused = false;

    function show(next) {
      items[index].classList.remove('is-active');
      index = next % items.length;
      items[index].classList.add('is-active');
    }

    function tick() {
      if (!paused) show(index + 1);
    }

    function start() {
      stop();
      // In de vaste rij op desktop staat alles al naast elkaar.
      if (bar.classList.contains('dk-usp-bar--fixed') && wide.matches) return;
      timer = window.setInterval(tick, interval);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    bar.addEventListener('touchend', function () { paused = false; }, { passive: true });

    if (wide.addEventListener) wide.addEventListener('change', start);
    start();
  }

  /* Hero ----------------------------------------------------------------- */

  function setupHero(hero) {
    if (!claim(hero)) return;
    var track = hero.querySelector('[data-dk-hero-track]');
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-dk-hero-dot]'));
    if (!track || !dots.length) return;

    var prev = hero.querySelector('[data-dk-hero-prev]');
    var next = hero.querySelector('[data-dk-hero-next]');

    function sync(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    /* Automatisch doorschuiven -------------------------------------------
       Pauzeert bij hover en bij aanraken, net als de USP-balk. Zodra de
       bezoeker zelf een pijl of stip gebruikt, stopt het voorgoed: hij heeft
       dan een keuze gemaakt en moet niet even later weggeschoven worden. */
    var reduced = mediaQuery('(prefers-reduced-motion: reduce)');
    var play = hero.hasAttribute('data-dk-autoplay') && !reduced.matches;
    var interval = (parseInt(hero.dataset.dkInterval, 10) || 6) * 1000;
    var autoTimer = null;
    var paused = false;

    function stopAuto() {
      play = false;
      if (autoTimer) window.clearInterval(autoTimer);
      autoTimer = null;
    }

    // Een slide is even breed als de track, maar niet elke omgeving heeft de
    // pagina al uitgelijnd: dan is `clientWidth` nul. Eerst de slide zelf
    // opmeten, dan de track, en als laatste terugval 1 — zonder die ondergrens
    // werd de stap nul (de slider bleef staan) en gaf de omslagdetectie
    // `Math.round(0 / 0)`, dus NaN. Zelfde aanpak als de carrousel hieronder.
    function slideWidth() {
      var eerste = track.firstElementChild;
      var gemeten = eerste ? eerste.getBoundingClientRect().width : 0;
      return gemeten || track.clientWidth || 1;
    }

    function currentIndex() {
      return Math.round(track.scrollLeft / slideWidth());
    }

    function tick() {
      if (paused) return;
      if (currentIndex() >= dots.length - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: slideWidth(), behavior: 'smooth' });
      }
    }

    if (play) {
      autoTimer = window.setInterval(tick, interval);
      hero.addEventListener('mouseenter', function () { paused = true; });
      hero.addEventListener('mouseleave', function () { paused = false; });
      hero.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      hero.addEventListener('touchend', function () { paused = false; }, { passive: true });
    }

    function step(richting) {
      stopAuto();
      track.scrollBy({ left: slideWidth() * richting, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        stopAuto();
        var index = parseInt(dot.dataset.dkHeroDot, 10);
        track.scrollTo({ left: slideWidth() * index, behavior: 'smooth' });
        sync(index);
      });
    });

    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        sync(Math.round(track.scrollLeft / track.clientWidth));
      }, 80);
    }, { passive: true });
  }

  /* Productcarrousel ------------------------------------------------------ */

  function setupCarousel(carousel) {
    if (!claim(carousel)) return;
    var track = carousel.querySelector('[data-dk-carousel-track]');
    var prev = carousel.querySelector('[data-dk-carousel-prev]');
    var next = carousel.querySelector('[data-dk-carousel-next]');
    if (!track || !prev || !next) return;

    function step() {
      var item = track.firstElementChild;
      // Eén kaart plus de tussenruimte; valt terug op driekwart van het venster.
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.75;
    }

    function syncArrows() {
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });

    var timer = null;
    track.addEventListener('scroll', function () {
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(syncArrows, 80);
    }, { passive: true });

    syncArrows();
  }

  function init(root) {
    var scope = root || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dk-usp]'), setupUsp);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dk-hero]'), setupHero);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dk-carousel]'), setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
